export enum BmsEditMode {
  Number = 0,
  String = 1,
  Timestamp = 2,
  Boolean = 3,
  XDatatype = 4,
  Enum = 5
}
